import {Action, createReducer, on} from '@ngrx/store';
import * as Actions from '@store/actions/config.action';
import {ConfigState, initialConfigState} from '@store/state/config.state';

export const initialState: {} | ConfigState = initialConfigState()

const ConfigReducer = createReducer(
    initialState,
    on(
        Actions.setConfig, (state: ConfigState | {}, {config}): ConfigState => {
            return {
                ...state,
                ...config
            };
        }),
    on(
        Actions.setConfigDefaultCountry, (state: ConfigState | {}, {country}): ConfigState | {} => {
            return {
                ...state,
                defaultCountry: country
            };
        }),
    on(
        Actions.setChangePriceGroupTo, (state: ConfigState | {}, {priceGroup}): ConfigState | {} => {
            return {
                ...state,
                changePriceGroupTo: priceGroup
            };
        })
);

export function reducer(state: ConfigState | {} | undefined, action: Action) {
    return ConfigReducer(state, action);
}
